import React, { useContext } from "react";
import botGif from "../Assets/Images/lN0AeE-unscreen.gif";
import { motion } from "framer-motion";
import bgImage from "../Assets/Images/colurfulbg.png";
import DataContext from "./Controller";

const Herosection = () => {
  const { toggleFormVisibility } = useContext(DataContext);

  return (
    <main className="w-full flex flex-col items-center justify-center bg-white px-[5vw] md:px-[10vw] min-h-screen mt-[50px] max-w-[1200px] mx-auto">
      
      {/* Text Section */}
      <aside className="w-full md:w-full flex flex-col items-center justify-center px-3 text-center mb-16">
        <h1 className="w-full font-extrabold my-2 text-2xl md:text-4xl text-[#E69219]">
          🎁 The Birthday Gift That Lasts ALL Year! 🎁
        </h1>
        <p className="text-sm md:text-2xl mt-2 text-[#06A5F9]">
          Tired of giving the same old birthday gifts? Give something unique: a 12-month subscription of personalised messages designed to inspire, motivate, and brighten their year, just £5 one-time payment.
        </p>
      </aside>

      {/* Image & Button Section */}
      <div className="w-full flex flex-col md:flex-row items-center justify-center gap-8">
        
        {/* Image Section */}
        <section
          className="w-[300px] md:w-[40%] h-[250px] md:h-[350px] flex items-center justify-center bg-center bg-cover rounded-xl"
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <img src={botGif} alt="bot" className="w-full h-auto object-contain" />
        </section>

        {/* Description & Button Section */}
        <div className="flex flex-col w-full md:w-[50%] text-center md:text-left">
          <h5 className="text-md md:text-2xl w-full capitalize font-bold text-[#06A5F9]">
            One personalised motivational message every month for 12 months powered by AI!
          </h5>

          {/* Button Section */}
          <div className="flex w-full justify-center md:justify-start mt-5">
            <motion.button
              className="w-[150px] h-[50px] bg-[#C8266F] text-white font-semibold p-4 rounded-lg shadow-lg hover:bg-pink-600 transition-all duration-300"
              initial={{ scale: 1 }}
              animate={{ scale: [1, 1.1, 1] }}
              transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
              onClick={toggleFormVisibility}
            >
              Get Started
            </motion.button>
          </div>
        </div>

      </div>
    </main>
  );
};

export default Herosection;
